<template>
  <section id="content">
    <loader v-if="loader == true"></loader>
    <div class="page page-hz-menu-layout">
      <div class="row form-group">
        <div class="col-md-2">
          <ul class="tabs-menu">
            <li :class="tab == 1 ? 'active' : ''" @click="tab = 1">
              <a href="javascript:void(0)">1. Simulação</a>
            </li>
            <li :class="tab == 2 ? 'active' : ''" @click="tab = 2">
              <a href="javascript:void(0)">2. Anexos</a>
            </li>
          </ul>
          <br />
          <div
            class="alert alert-success"
            v-if="aprovadoautomaticamente == true"
          >
            <strong><i class="fa fa-check"></i></strong>
            Simulação Aprovada.
          </div>

          <div
            class="alert alert-warning"
            v-if="aprovadoautomaticamente == false"
          >
            <strong><i class="fa fa-warning"></i></strong>
            Simulação Pendente de Aprovação.
          </div>
        </div>
        <div class="col-md-10">
          <section class="tile" v-if="tab == 1">
            <div class="tile-header dvd dvd-btm">
              <h1 class="custom-font">
                <strong>Dados</strong> Simulação #{{ proposta.id }}
              </h1>
              <ul class="controls"></ul>
            </div>
            <div class="tile-body">
              <div class="row">
                <div class="col-md-12">
                  <fieldset class="scheduler-border">
                    <legend class="scheduler-border">Vendedor</legend>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <select
                          name="tipo_proposta_id"
                          id="tipo_proposta_id"
                          class="form-control"
                          v-model="proposta.id_vendedor"
                          required
                          disabled
                        >
                          <option :value="proposta.id_vendedor">{{ proposta.nome_vendedor }}</option>
                        </select>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-2">
                  <fieldset class="scheduler-border">
                    <legend class="scheduler-border">Operação</legend>
                    <label>Tipo</label>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <select
                          name="tipo_proposta_id"
                          id="tipo_proposta_id"
                          class="form-control"
                          v-model="proposta.tipo_proposta_id"
                          required
                          disabled
                        >
                          <option value="1">Automóvel</option>
                          <option value="2">Motocicleta</option>
                        </select>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-10">
                  <fieldset class="scheduler-border">
                    <legend class="scheduler-border">Veículo</legend>
                    <div class="row form-group">
                      <div class="col-md-3">
                        <label for="marcas">Marca</label>
                        <div class="input-group">
                          <span class="input-group-btn" style="display: block">
                            <button
                              class="btn btn-success"
                              v-if="
                                editarVeiculo == false &&
                                proposta.simulacao == true
                              "
                              data-toggle="tooltip"
                              data-placement="bottom"
                              @click="alterarVeiculo()"
                              title="Editar Veículo"
                            >
                              <i class="fa fa-edit"></i>
                            </button>
                          </span>
                          <input
                            :type="editarVeiculo == true ? 'hidden' : 'text'"
                            disabled
                            name="marca"
                            id="marca_v"
                            v-model="objeto.marca"
                            class="form-control"
                          />
                        </div>
                        <input
                          type="hidden"
                          name="id_fipe"
                          id="fipe_codigo"
                          v-model="objeto.fipe_id"
                          class="form-control"
                        />
                        <div class="input-group">
                          <span class="input-group-btn">
                            <button
                              class="btn btn-danger"
                              v-if="
                                editarVeiculo == true &&
                                proposta.simulacao == true
                              "
                              data-toggle="tooltip"
                              data-placement="bottom"
                              @click="alterarVeiculo()"
                              title="Cancelar Edição de Veículo"
                            >
                              <i class="fa fa-times"></i>
                            </button>
                          </span>
                          <select
                            v-if="editarVeiculo == true"
                            name="marcas"
                            v-model="veiculo.marca"
                            id="marcas"
                            class="form-control"
                            required
                            :disabled="proposta.simulacao == false"
                            @change="getModelos()"
                          >
                            <option v-for="m in marcas" :value="m.Value">
                              {{ m.Label }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <label for="veiculo">Veículo</label>
                        <input
                          :type="editarVeiculo == true ? 'hidden' : 'text'"
                          name="modelo"
                          id="veiculo_modelo"
                          disabled
                          v-model="objeto.modelo"
                          class="form-control"
                        />
                        <select
                          v-if="editarVeiculo == true"
                          id="veiculo"
                          v-model="veiculo.modelo"
                          class="form-control"
                          :disabled="veiculo.marca == '' || !veiculo.marca"
                          required
                          @change="getAnosModelo()"
                        >
                          <option v-for="m in modelos" :value="m.Value">
                            {{ m.Label }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-2">
                        <label for="modelo">Ano</label>
                        <input
                          :type="editarVeiculo == true ? 'hidden' : 'text'"
                          name="ano"
                          id="ano_v"
                          disabled
                          v-model="objeto.ano_modelo"
                          class="form-control"
                        />
                        <select
                          v-if="editarVeiculo == true"
                          id="modelo"
                          v-model="veiculo.ano_modelo"
                          class="form-control"
                          :disabled="veiculo.marca == '' || !veiculo.marca"
                          @change="getVeiculo()"
                          required
                        >
                          <option v-for="m in anoModelo" :value="m.Value">
                            {{ m.Label }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-2">
                        <label>Valor Fipe <small>R$</small></label>
                        <input
                          :type="editarVeiculo == true ? 'hidden' : 'text'"
                          name="valor_fipe"
                          v-model="objeto.valor"
                          disabled
                          class="form-control currency"
                          placeholder="0,00"
                        />
                        <input
                          v-if="editarVeiculo == true"
                          type="text"
                          v-money="money"
                          name="valor_fipe"
                          id="valor_fipe"
                          readonly
                          v-model="veiculo.valor"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-12">
                      <fieldset class="scheduler-border">
                        <legend class="scheduler-border">Simulação</legend>
                        <div class="row form-group">
                          <div class="col-md-6">
                            <label>Valor a Contratar <small>R$</small></label>
                            <input
                              type="text"
                              v-money="money"
                              name="valor"
                              id="valor"
                              v-model="propostaValorProposta"
                              class="form-control"
                              @click="getOldValueProposta()"
                              @blur="aprovacaoParcelas()"
                            />
                          </div>
                          <div class="col-md-6">
                            <label>Valor de Entrada <small>R$</small></label>
                            <input
                              type="text"
                              class="form-control"
                              name="entrada"
                              :value="
                                calcEntrada(
                                  proposta.valor_proposta,
                                  objeto.valor
                                )
                              "
                              style="color: rgb(120, 184, 0) !important"
                              disabled
                            />
                          </div>
                        </div>
                        <div
                          class="row form-group"
                          v-if="
                            aprovadoautomaticamente == false &&
                            proposta.tipo_proposta_id != 2
                          "
                        >
                          <div class="col-md-6">
                            <label>R$ Valor Aprovado</label>
                            <input
                              type="text"
                              v-money="money"
                              name="valor_aprovado"
                              id="valor_aprovado"
                              v-model="proposta.valor_aprovado_criterios"
                              disabled
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-md-6">
                            <label>N°. Parcelas</label>
                            <input
                              type="number"
                              class="form-control"
                              name="paarcelas"
                              id="parcelas"
                              min="1"
                              max="60"
                              @click="getOldNParcelas()"
                              @blur="verificaParcelas()"
                              required
                              v-model="proposta.parcelas"
                            />
                          </div>
                          <div class="col-md-6">
                            <label>Dia 1° Parcela</label>
                            <datepicker
                              :language="languages.ptBR"
                              v-bind:format="format"
                              input-class="form-control data-parcela"
                              name="data_primeira_parcela"
                              id="data_primeira_parcela"
                              :disabledDates="disabledDates"
                              placeholder="DD/MM/AAAA"
                              required="required"
                              :open-date="dataMin"
                              @selected="setDataParcelas($event)"
                            >
                            </datepicker>
                          </div>
                          <div class="col-md-6">
                            <br />
                            <div class="form-check form-check-inline">
                              <label>Bônus</label><br />
                              <input
                                class="form-check-input"
                                :checked="proposta.percentual_retorno == 0"
                                type="radio"
                                name="inlineRadioOptions"
                                id="r0"
                                value="0"
                                @click="validaRetorno(1)"
                              />
                              <label
                                class="form-check-label"
                                for="inlineRadio1"
                              >
                                B0
                              </label>
                              <input
                                class="form-check-input"
                                :checked="proposta.percentual_retorno == 1"
                                type="radio"
                                name="inlineRadioOptions"
                                id="r1"
                                value="1"
                                @click="validaRetorno(2)"
                              />
                              <label
                                class="form-check-label"
                                for="inlineRadio2"
                              >
                                B1
                              </label>
                              <input
                                class="form-check-input"
                                :checked="proposta.percentual_retorno == 2"
                                type="radio"
                                name="inlineRadioOptions"
                                id="r2"
                                value="2"
                                @click="validaRetorno(3)"
                              />
                              <label
                                class="form-check-label"
                                for="inlineRadio3"
                              >
                                B2
                              </label>
                              <input
                                class="form-check-input"
                                :checked="proposta.percentual_retorno == 3"
                                type="radio"
                                name="inlineRadioOptions"
                                id="r3"
                                value="3"
                                @click="validaRetorno(4)"
                              />
                              <label
                                class="form-check-label"
                                for="inlineRadio3"
                              >
                                B3
                              </label>
                              <template v-if="proposta.id_tipo_proposta != 2">
                                <input
                                  class="form-check-input"
                                  :checked="proposta.percentual_retorno == 4"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  id="r4"
                                  value="4"
                                  @click="validaRetorno(5)"
                                />
                                <label
                                  class="form-check-label"
                                  for="inlineRadio3"
                                >
                                  B4
                                </label>
                              </template>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label
                              >Valor Aproximado Parcela <small>R$</small></label
                            >
                            <input
                              type="text"
                              v-money="money"
                              name="valor_par"
                              id="valor_par"
                              disabled
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div
                            class="col-md-6"
                            style="margin-top: 25px !important"
                          >
                            <button
                              class="btn btn-success btn-block"
                              @click="calcularParcelas()"
                              v-if="proposta.simulacao == true"
                              :disabled="
                                proposta.data_primeira_parcela == '' ||
                                desabilitabotaoCalcular
                              "
                            >
                              <i class="fa fa-calculator"></i> Calcular
                            </button>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <div
                  :class="proposta.categoria_id == 1 ? 'col-md-8' : 'col-md-8'"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <fieldset class="scheduler-border">
                        <legend class="scheduler-border">Proponente</legend>
                        <div class="row">
                          <div class="col-md-4 form-group">
                            <label>CPF</label>
                            <input
                              type="text"
                              v-mask="['###.###.###-##']"
                              class="form-control"
                              placeholder="000.000.000-00"
                              name="cpf"
                              id="cpf"
                              :disabled="!veiculo.ano || veiculo.ano == ''"
                              v-model="proponente.cpfcnpj"
                              required
                            />
                          </div>
                          <div class="col-md-8 form-group">
                            <label>Nome</label>
                            <input
                              type="text"
                              name="nome"
                              id="nome"
                              class="form-control"
                              v-model="proponente.nome"
                              disabled
                              placeholder="NOME DO PROPONENTE"
                            />
                          </div>
                          <div class="col-md-6 form-group">
                            <label for="tipo_renda">Tipo Renda</label>
                            <select
                              name="tipo_renda"
                              id="tipo_renda"
                              class="form-control"
                              required
                              disabled
                              v-model="proponente.tipo_renda"
                            >
                              <option value="9">AGROPECUÁRIA</option>
                              <option value="3">APOSENTADORIA</option>
                              <option value="1">PRO-LABORE</option>
                              <option value="0">SALÁRIO</option>
                              <option value="8">
                                RENDIMENTO NÃO COMPROVADO
                              </option>
                            </select>
                          </div>
                          <div class="col-md-4 form-group">
                            <label>Valor Renda R$</label>
                            <input
                              type="text"
                              v-money="money"
                              name="renda"
                              id="renda"
                              class="form-control"
                              v-model="proponente.renda"
                              disabled
                              placeholder="RENDA DO PROPONENTE"
                            />
                          </div>
                          <div class="col-md-6 form-group">
                            <label>PA</label>
                            <select
                              name="pa_id"
                              id="pa_id"
                              v-model="proponente.pa_id"
                              class="form-control"
                              :disabled="proponente.cooperado == true"
                              required
                            >
                              <option
                                v-for="p in pas"
                                :value="p.cod_ponto_atendimento"
                                v-if="p.ordenacao != 97"
                              >
                                {{ p.nome_ponto_atendimento }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-6 form-group">
                            <label>Data Nascimento</label>
                            <input
                              class="form-control data-parcela"
                              name="data_nascimento"
                              id="data_nascimento"
                              :disabledDates="disabledDates"
                              placeholder="DD/MM/AAAA"
                              required="required"
                              :disabled="
                                proposta.cpfcnpj == '' || !proposta.cpfcnpj
                              "
                              :value="
                                $utils.formatDate(proposta.data_nascimento)
                              "
                            />
                          </div>
                          <div class="col-md-6 form-group">
                            <label>Estado civil</label>
                            <input
                              name="estado_civil"
                              id="estado_civil"
                              v-model="proposta.estado_civil"
                              class="form-control"
                              :disabled="
                                proposta.cpfcnpj == '' || !proposta.cpfcnpj
                              "
                              required
                            />
                          </div>
                          <div class="col-md-6 form-group">
                            <label>Naturalidade</label>
                            <input
                              type="text"
                              name="naturalidade"
                              id="naturalidade"
                              class="form-control"
                              :value="proposta.estado + ' - ' + proposta.cidade"
                              disabled
                              placeholder="NATURALIDADE"
                            />
                          </div>
                          <div
                            class="col-md-6 form-group"
                            v-if="proponente.tipo_renda != 3"
                          >
                            <label>Data inicio emprego</label>
                            <select
                              class="form-control"
                              id="data_inicio_emprego"
                              placeholder="DD/MM/AAAA"
                              required="required"
                              :disabled="
                                proposta.cpfcnpj == '' || !proposta.cpfcnpj
                              "
                              v-model="proposta.data_emprego"
                              name="data_inicio_emprego"
                            >
                              <template v-if="!isFeirao">
                                <option value="1">Menos de 1 ano</option>
                                <option value="2">Mais de 1 ano</option>
                              </template>
                              <template v-else>
                                <option value="1">Menos de 6 meses</option>
                                <option value="2">Mais de 6 meses</option>
                              </template>
                            </select>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 form-group">
                            <label>Celular</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="(99) 9 9999 9999"
                              v-mask="['(##) # #### ####']"
                              name="celular"
                              minlength="14"
                              id="celular"
                              v-model="proponente.celular"
                              required
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <br />
                            <label class="checkbox checkbox-custom-alt">
                              <input
                                type="checkbox"
                                :checked="proponente.cooperado == true"
                                disabled
                              /><i></i> Cooperado Sicoob Crediauc
                            </label>
                          </div>
                          <div class="col-md-6">
                            <label
                              v-if="proposta.lojista_id == 165"
                              class="checkbox checkbox-custom-alt"
                            >
                              <input
                                type="checkbox"
                                id="checktr"
                                name="checktr"
                              /><i></i>Testar Nova Função Cálculo
                            </label>
                          </div>
                          <div class="col-md-6">
                            <label
                              v-if="proposta.lojista_id == 165"
                              class="checkbox checkbox-custom-alt"
                            >
                              <input
                                type="checkbox"
                                id="checkgravame"
                                name="checkgravame"
                              /><i></i>Não considerar Gravame
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="row" v-if="aprovadoautomaticamente == false">
                    <div class="col-md-12">
                      <fieldset class="scheduler-border">
                        <legend class="scheduler-border">Avalista</legend>
                        <div class="row form-group">
                          <div class="col-md-3">
                            <label
                              >CPF <small><b>*opcional</b></small></label
                            >
                            <input
                              type="text"
                              v-mask="['###.###.###-##']"
                              class="form-control"
                              placeholder="000.000.000-00"
                              name="cpfAval"
                              id="cpfAval"
                              v-model="avalista[0].cpfcnpj"
                              @change="validaCPF(0)"
                              required
                            />
                          </div>
                          <div class="col-md-6">
                            <label
                              >Nome <small><b>*opcional</b></small></label
                            >
                            <input
                              type="text"
                              name="nomeAval"
                              id="nomeAval"
                              class="form-control"
                              v-model="avalista[0].nome"
                              :disabled="avalista[0].cpfcnpj == ''"
                              placeholder="NOME DO AVALISTA"
                            />
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-md-3">
                            <label
                              >CPF <small><b>*opcional</b></small></label
                            >
                            <input
                              type="text"
                              v-mask="['###.###.###-##']"
                              class="form-control"
                              placeholder="000.000.000-00"
                              name="cpfAval2"
                              id="cpfAval2"
                              v-model="avalista[1].cpfcnpj"
                              @change="validaCPF(1)"
                              required
                            />
                          </div>
                          <div class="col-md-6">
                            <label
                              >Nome <small><b>*opcional</b></small></label
                            >
                            <input
                              type="text"
                              name="nomeAval2"
                              id="nomeAval2"
                              class="form-control"
                              v-model="avalista[1].nome"
                              :disabled="avalista[1].cpfcnpj == ''"
                              placeholder="NOME DO AVALISTA"
                            />
                            <br /><br />
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
                <!-- <div v-if="proposta.categoria_id == 1" class="col-md-3">
                  <div class="row">
                    <div class="col-md-12">
                      <fieldset class="scheduler-border">
                        <legend class="scheduler-border">Benefícios</legend>
                        <div class="row form-group">
                          <div class="col-md-12">
                            <p style="font-size: 17px">
                              <label class="checkbox checkbox-custom-alt">
                                <input
                                  type="checkbox"
                                  id="checkSeguro"
                                  name="checkSeguro"
                                  :checked="proposta.seguro"
                                  @click="calcularParcelas()"
                                  v-model="proposta.seguro"
                                />
                                <i></i>
                                <strong>Seguro terceiro</strong>
                              </label>
                            </p>
                            <p><strong>Coberturas:</strong></p>
                            <div id="listaBeneficios">
                              <p
                                :class="
                                  !proposta.seguro
                                    ? 'text-red inactiveSeguro'
                                    : ''
                                "
                              >
                                <i
                                  :class="
                                    proposta.seguro
                                      ? 'text-greensea fa fa-check-circle'
                                      : 'text-red fa fa-times-circle'
                                  "
                                ></i>
                                Danos materiais a terceiro:
                                <strong>R$ 100.000,00</strong>
                              </p>
                              <p
                                :class="
                                  !proposta.seguro
                                    ? 'text-red inactiveSeguro'
                                    : ''
                                "
                              >
                                <i
                                  :class="
                                    proposta.seguro
                                      ? 'text-greensea fa fa-check-circle'
                                      : 'text-red fa fa-times-circle'
                                  "
                                ></i>
                                Danos corporais a terceiro:
                                <strong>R$ 100.000,00</strong>
                              </p>
                              <p
                                :class="
                                  !proposta.seguro
                                    ? 'text-red inactiveSeguro'
                                    : ''
                                "
                              >
                                <i
                                  :class="
                                    proposta.seguro
                                      ? 'text-greensea fa fa-check-circle'
                                      : 'text-red fa fa-times-circle'
                                  "
                                ></i>
                                Danos morais: <strong>R$ 10.000,00</strong>
                              </p>
                              <p
                                :class="
                                  !proposta.seguro
                                    ? 'text-red inactiveSeguro'
                                    : ''
                                "
                              >
                                <i
                                  :class="
                                    proposta.seguro
                                      ? 'text-greensea fa fa-check-circle'
                                      : 'text-red fa fa-times-circle'
                                  "
                                ></i>
                                Assistência 24 horas (Guincho) - *300KM em caso
                                de sinistro e *200KM em caso de pane
                              </p>
                              <p
                                :class="
                                  !proposta.seguro
                                    ? 'text-red inactiveSeguro'
                                    : ''
                                "
                              >
                                <i
                                  :class="
                                    proposta.seguro
                                      ? 'text-greensea fa fa-check-circle'
                                      : 'text-red fa fa-times-circle'
                                  "
                                ></i>
                                <strong>Válido por 1 ano</strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="row" align="center">
                <div>
                  <button
                    class="btn btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4a mb-10 btn-lg btn-continuar"
                    :disabled="ativabotoes"
                    v-if="proposta.simulacao == true"
                    @click="enviar()"
                  >
                    Enviar para Análise
                  </button>
                  <button
                    class="btn btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4a mb-10 btn-lg btn-continuar"
                    :disabled="ativabotoes"
                    v-if="proposta.simulacao == true"
                    @click="save()"
                  >
                    Salvar Simulação
                  </button>
                  <router-link
                    :to="{ name: 'IndexPropostas' }"
                    class="btn btn-default btn-border btn-rounded-20 btn-ef btn-ef-4 btn-ef-4a mb-10 btn-lg"
                    style="padding-top: 6px !important"
                  >
                    Cancelar</router-link
                  >
                </div>
              </div>
            </div>
          </section>
          <section class="tile" v-if="tab == 2">
            <div class="tile-header dvd dvd-btm">
              <h1 class="custom-font">
                <strong>Anexos</strong> Simulação #{{ proposta.id }}
              </h1>
            </div>
            <div class="tile-body">
              <div class="row">
                <div class="col-md-4">
                  <fieldset class="scheduler-border">
                    <legend class="scheduler-border">Novo Anexo</legend>
                    <form @submit.prevent="anexar" id="form_anexo">
                      <div class="row form-group">
                        <div class="col-md-12">
                          <label for="">Nome</label>
                          <input
                            type="text"
                            id="nome_anexo"
                            name="nome_anexo"
                            placeholder="NOME PARA O ARQUIVO ANEXADO"
                            class="form-control"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <label for="">Arquivo</label>
                          <input
                            type="file"
                            id="anexo"
                            name="anexo"
                            placeholder="SELECIONE UM ARQUIVO"
                            class="form-control"
                            required=""
                            style="
                              padding-top: 0px !important;
                              border: 1px solid #ddd;
                              text-transform: capitalize !important;
                            "
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <hr />
                          <button type="submit" class="btn btn-success">
                            <i class="fa fa-paperclip"></i> Anexar
                          </button>
                        </div>
                      </div>
                    </form>
                  </fieldset>
                </div>
                <div class="col-md-8">
                  <fieldset class="scheduler-border">
                    <legend class="scheduler-border">Lista de Anexos</legend>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <p v-if="anexos.length == 0" align="center">
                          <br /><br />Não existem anexos para está simulação.
                        </p>
                        <table
                          class="table table-hover table-striped"
                          v-if="anexos.length > 0"
                        >
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="a in anexos">
                              <td>{{ a.nome_anexo }}</td>
                              <td style="text-align: right">
                                <button
                                  class="btn btn-danger btn-xs"
                                  @click="excluirAnexo(a.id)"
                                  v-if="proposta.simulacao == true"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Excluir Anexo"
                                >
                                  <i class="fa fa-times"></i>
                                </button>
                                <a
                                  :href="
                                    'http://portalsicoobcrediauc.com/backend-auto/uploads/anexos/' +
                                    a.proposta_id +
                                    '/' +
                                    a.arquivo
                                  "
                                  class="btn btn-primary btn-xs"
                                  download="download"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Baixar Anexo"
                                >
                                  <i class="fa fa-download"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
.inactiveSeguro {
  text-decoration: line-through;
}
</style>
<script>
import HeaderPropostas from "./_header.vue";
import { mask } from "vue-the-mask";
import { VMoney } from "v-money";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
var moment = require("moment");

window.addEventListener("beforeunload", function (e) {
  e.preventDefault();
  e.returnValue = "";
});

export default {
  name: "editar-propostas",

  directives: {
    mask,
    money: VMoney,
  },

  data() {
    return {
      isFeirao: false,
      editarVeiculo: false,
      anoBase: moment().format("YYYY") - 15,
      dataMin: moment(moment().add(31, "days").calendar(), "MM-DD-YYYY").format(
        "YYYY-MM-DD"
      ),
      dataLimite: this.getDiasLimite(),
      dataIni: new Date(),
      dataAtual: moment().format("YYYY-MM-DD"),
      anoAtual : moment().format("yyyy"),
      disabledDates: {
        daysOfMonth: [
          1, 2, 3, 4, 6, 7, 8, 9, 11, 12, 13, 14, 16, 17, 18, 19, 20, 21, 22,
          23, 24, 25, 26, 27, 28, 29, 30, 31,
        ], // Disable 29th, 30th and 31st of each month
      },
      defaultDate: this.dataLimite,
      language: "pt-br",
      languages: lang,
      format: "dd/MM/yyyy",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " ",
        precision: 2,
        masked: true,
      },
      moneyParcelas: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
        masked: true,
      },
      loader: true,
      tab: 1,
      avalista: [
        {
          nome: "",
          cpfcnpj: "",
        },
        {
          nome: "",
          cpfcnpj: "",
        },
      ],
      proponente: {},
      proposta: {},
      objeto: {},
      anexo: {},
      pas: [],
      marcas: [],
      veiculo: {},
      parcelas: [],
      modelos: [],
      anexos: [],
      anoModelo: [],
      entrada: "",
      ativabotoes: true,
      ano_veiculo: 0,
      tipoRetorno: null,
      percentual_ret: null,
      checktr: "",
      checkgravame: "",
      desabilitabotaoCalcular: false,
      aprovadoautomaticamente: false,
      propostaValorProposta: 0,
      oldPropostaValorProposta: 0,
      oldNParcelas: 0,
      oldDataParcelas: "",
    };
  },

  components: {
    "header-propostas": HeaderPropostas,
    Datepicker,
  },

  methods: {
    getOldValueProposta() {
      this.oldPropostaValorProposta = this.propostaValorProposta;
    },

    getOldNParcelas() {
      this.oldNParcelas = this.proposta.parcelas;
    },

    setDataParcelas(e) {
      $("#data_primeira_parcela").val(moment(e).format("DD/MM/YYYY"));
      this.calcularParcelas();
    },

    getDataFeirao: function () {
      var $this = this;
      let data = moment().format("YYYY-MM-DD");
      $this.$http.get("/propostas/isFeira").then(function (response) {
        if (response.data.data_inicio != 0 && response.data.data_fim != 0) {
          let dataFeirao = [response.data.data_inicio, response.data.data_fim];
          if (dataFeirao.indexOf(data) != "-1") {
            $this.isFeirao = true;
            return;
          }
        }
        $this.isFeirao = false;
      });
    },

    getDiasLimite: function () {
      var data = moment().format("YYYY-MM-DD");
      var dataIni = moment("2022-12-01").format("YYYY-MM-DD");
      var dataFin = moment("2022-12-31").format("YYYY-MM-DD");
      if (data >= dataIni && data <= dataFin) {
        return moment(
          moment().add(121, "days").calendar(),
          "MM-DD-YYYY"
        ).format("YYYY-MM-DD");
      }
      return moment(moment().add(61, "days").calendar(), "MM-DD-YYYY").format(
        "YYYY-MM-DD"
      );
    },

    aprovacaoParcelas: function () {
      if (this.oldPropostaValorProposta != this.propostaValorProposta) {
        this.oldPropostaValorProposta = this.propostaValorProposta;
        this.calcularParcelas();
      }

      if (this.oldDataParcelas != $("#data_primeira_parcela").val()) {
        this.oldDataParcelas = $("#data_primeira_parcela").val();
        this.calcularParcelas();
      }

      if (this.oldNParcelas != this.proposta.parcelas) {
        this.oldNParcelas = this.proposta.parcelas;
        this.calcularParcelas();
      }
    },

    validaCPF: function (indice) {
      var $this = this;
      var cpf = this.avalista[indice].cpfcnpj;
      cpf = cpf
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "");

      var valido = this.$utils.validaCPF(cpf);

      if (valido == false) {
        return this.$toastr(
          "warning",
          "CPF informado é inválido " + $this.avalista[indice].cpf + ".",
          "Atenção!"
        );
      }
    },

    verificaParcelas: function () {
      let anos =  (this.anoAtual - this.veiculo.ano.substring(0, 4));

      if (this.proposta.parcelas > 60) {
        $("#parcelas").val(60);
        this.proposta.parcelas = 60;
        return this.$toastr(
          "warning",
          "Número máximo de quantidade de parcelas deve ser de 1 a 60.",
          "Atenção!"
        );
      }

      if (anos >= 11 && this.proposta.parcelas > 48)  {
        $("#parcelas").val(48);
        this.proposta.parcelas = 48;
        return this.$toastr(
          "warning",
          "Número máximo de parcelas para veículos de 11 a 15 anos (48x)",
          "Atenção!"
        );
      }

      if (this.proposta.parcelas < 1) {
        $("#parcelas").val(1);
        this.proposta.parcelas = 1;
        return this.$toastr(
          "warning",
          "Número máximo de quantidade de parcelas deve ser de 1 a 60.",
          "Atenção!"
        );
      }

      this.aprovacaoParcelas();
    },

    alterarVeiculo: function () {
      var $this = this;
      $("#valor_par").val("0,00");
      $this.propostaValorProposta = "0,00";
      this.ativabotoes = true;
      this.editarVeiculo = !this.editarVeiculo;
      if (this.editarVeiculo) {
        $this.proposta.valor_proposta = 0;
        this.editarVeiculo = true;
        setTimeout(function () {
          $("#modelo")
            .select2()
            .change(function () {
              console.log("ano");
              $this.proposta.valor_proposta = 0;
              $this.veiculo.ano = $(this).val();
              $this.ano_veiculo = $(this).val().substr(0, 4);
              $this.getVeiculo();
            });

          $("#veiculo")
            .select2()
            .change(function () {
              $this.veiculo.ano = null;
              $this.veiculo.modelo = $(this).val();
              $this.getAnosModelo();
            });

          $("#marcas")
            .select2()
            .change(function () {
              $this.veiculo.marca = $(this).val();
              $this.getModelos();
            });

          $("#tipo_proposta_id")
            .select2()
            .change(function () {
              $this.proposta.tipo_proposta_id = $(this).val();
              $this.getMarcas();
            });
        }, 100);
      } else {
        $("#modelo").select2("destroy");
        $("#veiculo").select2("destroy");
        $("#marcas").select2("destroy");
        if ($("#tipo_proposta_id").length) {
          $("#tipo_proposta_id").select2("destroy");
        }
      }
    },

    calcularParcelas: function () {
      var $this = this;

      $this.loader = true;
      this.ativabotoes = false;
      if ($("#valor_fipe").val() != undefined) {
        if ($("#valor_fipe").val().trim() == "0,00") {
          swal({
            title: "Atenção!",
            text: "Dados do Veículo estão Incompletos. Verifique!",
            type: "warning",
          });
          return;
        }
      }

      if ($this.proposta.valor_proposta == "0,00 ") {
        swal({
          title: "Atenção!",
          text: "Por favor, informe o valor a ser contratado.",
          type: "warning",
        });
        return;
      }

      if ($this.proposta.data_primeira_parcela == "") {
        swal({
          title: "Atenção!",
          text: "Por favor, informe a Data da Primeira Parcela.",
          type: "warning",
        });
        return;
      }

      var ano_veiculo = 0;
      if (
        !$this.proposta.data_primeira_parcela ||
        $this.proposta.data_primeira_parcela == "" ||
        $this.proposta.data_primeira_parcela == null
      ) {
        return $this.$toastr(
          "warning",
          "Data da primeira parcela é obrigatório.",
          "Atenção!"
        );
      }

      //var checkSeguro = $("input[name='checkSeguro']:checked").length > 0;
      var checktr = $("input[name='checktr']:checked").length > 0;
      var checkgravame = $("input[name='checkgravame']:checked").length > 0;

      ano_veiculo = $this.ano_veiculo;
     
      if ($this.ano_veiculo == 0) {
        ano_veiculo = $this.objeto.ano_modelo;
        $this.objeto.ano_modelo = ano_veiculo;
      }
  
      $this.proposta.valor_proposta = $this.propostaValorProposta;
    

      $this.$http
        .post("/propostas/simular/parcela", {
          ano_modelo: ano_veiculo,
          valor_retorno: $this.proposta.valor_retorno,
          tipo_proposta_id: $this.proposta.tipo_proposta_id,
          parcelas: $this.proposta.parcelas,
          id: $this.proposta.id,
          created_at: $this.proposta.created_at,
          data_primeira_parcela: $("#data_primeira_parcela").val(),
          valor_proposta: $this.proposta.valor_proposta,
          valor_alienacao: 400,
          score: $this.proponente.score,
          valor_fipe: $this.objeto.valor,
          percentual_retorno: $this.percentual_ret,
          seguro: 0, //checkSeguro ? 1 : 0,
          tr: checktr ? "S" : "N",
          has_gravame: checkgravame ? "N" : "S",
          categoria_id: $this.proposta.categoria_id,
          objeto: $this.objeto,
          lojista_id: $this.proposta.lojista_id,
          proponente_id: $this.proponente.id,
          proponente_cpf: $this.proponente.cpfcnpj,
          tipo_renda: $this.proponente.tipo_renda,
          is_cooperado: $this.proponente.cooperado,
          pa_id: $this.proponente.pa_id,
          data_nascimento: $this.proposta.data_nascimento,
          cidade_id: $this.proposta.cidade_id,
          estado_civil: $this.proposta.estado_civil,
          data_emprego: $this.proposta.data_emprego
        })
        .then(function (response) {
          var valorRetorno = parseFloat(
            response.data.valor_retorno / response.data.parcelas
          );

          $this.aprovadoautomaticamente = response.data.aprovacao_automatica;

          $("#valor_par").val(response.data.parcela_iof).toFixed(2);
          $("#valor_parcela").val(response.data.parcela_iof).toFixed(2);
          $this.proposta.taxa = response.data.taxa;
          $this.proposta.parcela_sem_retorno =
            response.data.parcela_sem_retorno;
          $this.proposta.valor_retorno = response.data.valor_retorno.toFixed(2);
          // $this.proposta.aprovacao_automatica =
          //   response.data.aprovacao_automatica;
          //$this.proposta.aprovacao_automatica =  response.data.aprovacao_automatica;
          //  response.data.aprovacao_automatica;
          $this.proposta.iof = response.data.iof;
          $this.loader = false;

          $this.save(1);
        })
        .catch(function (error) {
          $this.loader = false;
          if (error.response) {
            if (error.response.data) {
              $("#valor_par").val(0.00);
              $this.aprovadoautomaticamente =
                error.response.data.aprovacao_automatica;
              swal({
                title: "Atenção!",
                text: error.response.data.msg,
                type: "warning",
              });
              
            }
          } else {
            swal.close();
          }
        });
    },

    alteraParcelas: function (parcelas, valor, taxa, parcela_sem_retorno) {
      $("#valor_par").val(valor);
      $("#parcelas").val(parcelas);
      this.proposta.parcelas = parcelas;
      this.proposta.taxa = taxa;
      this.proposta.parcela_sem_retorno = parcela_sem_retorno;
    },

    calcEntrada: function (valorProposta, valorFipe) {
      var valorProposta = valorProposta + " ";
      valorProposta = valorProposta
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(",", ".");

      var valorFipe = valorFipe + " ";
      valorFipe = valorFipe
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(",", ".");

      var entrada = parseFloat(valorFipe) - parseFloat(valorProposta);

      if (entrada <= 0) {
        return "0,00";
      }

      return this.$utils.numberToReal(entrada);
    },

    getPas: function () {
      var $this = this;
      $this.$http.get("/pas").then(function (response) {
        $this.pas = response.data;
      });
    },

    save: function (redir) {
      var $this = this;

      if ($this.proponente.celular != null) {
        if ($this.proponente.celular.length > 0) {
          if ($this.proponente.celular.length < 14) {
            return $this.$toastr(
              "warning",
              "O campo celular precisa de no mínimo 14 caracteres"
            );
          }
        }
      }

      $this.proposta.simulacao = 0;

      $this.loader = true;
      //var checkSeguro = $("input[name='checkSeguro']:checked").length > 0;
      $this.proposta.seguro = 0; //checkSeguro ? 1 : 0;

      if (redir != 1) {
        redir = 0;
      }

      var avalistas = [];
      var indiceAval = 0;

      if ($this.avalista[0].cpfcnpj != "" && $this.avalista[0].nome != "") {
        avalistas[indiceAval] = {};
        avalistas[indiceAval].cpfcnpj = $this.avalista[0].cpfcnpj;
        avalistas[indiceAval].nome = $this.avalista[0].nome;
        indiceAval++;
      }

      if ($this.avalista[1].cpfcnpj != "" && $this.avalista[1].nome != "") {
        avalistas[indiceAval] = {};
        avalistas[indiceAval].cpfcnpj = $this.avalista[1].cpfcnpj;
        avalistas[indiceAval].nome = $this.avalista[1].nome;
      }

      $this.proposta.percentual_retorno = $this.percentual_ret;

      // $this.proposta.valor_parcela_calculado = $("#valor_par").val();

      $this.$http
        .post("/propostas/" + $this.proposta.id, {
          proposta: $this.proposta,
          objeto: $this.objeto,
          proponente: $this.proponente,
          avalistas: avalistas,
        })
        .then(function (response) {
          if (response.data.aprovacao_automatica == true) {
            $this.$toastr(
              "success",
              "Simulação aprovada com base nos dados informados.",
              "Atenção!"
            );
          } else {
            $this.$toastr(
              "success",
              "Dados alterados com sucesso.",
              "Atenção!"
            );
          }

          $this.editarVeiculo = false;

          if (redir == 1) {
            return $this.getProposta();
          }

          return $this.$router.push({ name: "IndexPropostas" });
        })
        .catch(function (error) {
          $this.proposta.simulacao = true;
          $this.loader = false;
        });
    },

    async validaRetorno(tipo) {
      var $this = this;
      $this.tipoRetorno = tipo;
      var valorProposta = this.proposta.valor_proposta + " ";
      valorProposta = valorProposta
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(",", ".");
      var valorRetorno = this.proposta.valor_retorno + " ";
      valorRetorno = valorRetorno
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace(",", ".");
      //$this.desabilitabotaoCalcular = true;
      if (parseFloat(valorProposta).toFixed(2) > 0.0) {
        $this.loader = true;
        //if (parseFloat((parseFloat(valorRetorno) * 100) / parseFloat(valorProposta)).toFixed(2) > parseFloat(this.limiteRetorno)) {
        await $this.$http
          .get("/lojista/limiteretorno/" + tipo)
          .then(function (response) {  
            $this.proposta.percentual_ret  = 0;
            if (response.data[0].percentual > 0) {
              $this.percentual_ret = response.data[0].percentual;
              var valorPermitido =
                (response.data[0].percentual / 100) * parseFloat(valorProposta);
              $this.proposta.valor_retorno = valorPermitido.toFixed(2);
              //$this.desabilitabotaoCalcular = false;
              $this.proposta.percentual_retorno = response.data[0].percentual;
            } else {
              //$this.desabilitabotaoCalcular = false;
              $this.proposta.valor_retorno = 0;
              $this.percentual_ret =  response.data[0].percentual;
              $this.proposta.percentual_retorno = response.data[0].percentual;
            }

            $this.calcularParcelas();
          });
        //return this.$toastr('warning', 'Valor máximo de retorno permitido R$' + this.$utils.numberToReal(valorPermitido), 'Atenção!');
        // }
      }
    },

    enviar: function () {
      var $this = this;

      if (
        $this.proposta.data_primeira_parcela == "" ||
        $this.proposta.data_primeira_parcela == null
      ) {
        return $this.$toastr(
          "warning",
          "O campo Data da Primeira Parcela é obrigatório.",
          "Atenção!"
        );
      }

      var avalistas = [];
      var indiceAval = 0;

      if ($this.avalista[0].cpfcnpj != "" && $this.avalista[0].nome != "") {
        avalistas[indiceAval] = {};
        avalistas[indiceAval].cpfcnpj = $this.avalista[0].cpfcnpj;
        avalistas[indiceAval].nome = $this.avalista[0].nome;
        indiceAval++;
      }

      if ($this.avalista[1].cpfcnpj != "" && $this.avalista[1].nome != "") {
        avalistas[indiceAval] = {};
        avalistas[indiceAval].cpfcnpj = $this.avalista[1].cpfcnpj;
        avalistas[indiceAval].nome = $this.avalista[1].nome;
      }

      $this.loader = true;
      $this.proposta.simulacao = 1;

      $this.$http
        .post("/propostas/" + $this.proposta.id, {
          proposta: $this.proposta,
          objeto: $this.objeto,
          proponente: $this.proponente,
          avalistas: avalistas,
        })
        .then(function (response) {
          if (response.data.aprovacao_automatica == true) {
            $this.$toastr(
              "success",
              "Simulação aprovada com base nos dados informados.",
              "Atenção!"
            );
          } else {
            $this.$toastr(
              "success",
              "Dados alterados com sucesso.",
              "Atenção!"
            );
          }

          $this.editarVeiculo = false;
          return $this.$router.push({ name: "IndexPropostas" });
        })
        .catch(function (error) {
          $this.proposta.simulacao = false;
          $this.loader = false;
        });
    },

    getAnexos: function () {
      var $this = this;
      $this.anexos = [];

      $this.$http
        .get("/propostas/" + $this.$route.params.id + "/anexos")
        .then(function (response) {
          $this.anexos = response.data;
        })
        .catch(function (erro) {});
    },

    anexar: function () {
      var $this = this;
      $this.loader = true;
      var form = document.getElementById("form_anexo");
      var formData = new FormData(form);

      $this.$http
        .post("/propostas/anexar/" + $this.$route.params.id, formData)
        .then(function (response) {
          $("#arquivo").val("");
          $("#nome_anexo").val("");
          $this.loader = false;
          $this.getAnexos();
        })
        .catch(function (error) {
          $this.loader = false;
        });
    },

    excluirAnexo: function (id) {
      var $this = this;
      $this.loader = true;

      swal({
        title: "Atenção",
        text: "Deseja realmente excluir este anexo?",
        type: "warning",
        buttons: true,
        showCancelButton: true,
        dangerMode: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((willDelete) => {
        if (willDelete.value) {
          $this.$http
            .delete("/propostas/anexos/" + $this.proposta.id + "/" + id)
            .then(function () {
              $this.getAnexos();
              $this.loader = false;
              swal.close();
            })
            .catch(function (error) {
              $this.loader = false;
              swal.close();
            });
        } else {
          $this.loader = false;
          swal.close();
        }
      });
    },

    getProposta: function () {
      var $this = this;
      $this.$http
        .get(
          "/propostas/" +
            $this.$route.params.id +
            "/" +
            $this.$route.params.origem +
            "/edit"
        )
        .then(function (response) {
          $this.proponente = response.data.proponente;
          $this.proposta = response.data.proposta;
          $this.objeto = response.data.objeto;
          $this.objeto.valor = $this.$utils.numberToReal($this.objeto.valor);
          $this.parcelas = response.data.parcelas;
          var avalistas = response.data.avalistas.data;

          $this.aprovadoautomaticamente =
            response.data.proposta.aprovacao_automatica;

          $this.propostaValorProposta = $this.proposta.valor_proposta;

          $this.percentual_ret = $this.proposta.percentual_retorno;
          $this.proposta.alienacao = response.data.proposta.valor_alienacao;

          switch ($this.percentual_ret) {
            case "0.00":
              $this.tipoRetorno = 1;
              break;
            case "1.00":
              $this.tipoRetorno = 2;
              break;
            case "2.00":
              $this.tipoRetorno = 3;
              break;
            case "3.00":
              $this.tipoRetorno = 4;
              break;
            case "4.00":
              $this.tipoRetorno = 5;
              break;
          }
          if (response.data.mensagem != "") {
            swal({
              title: "Atenção!",
              text: response.data.mensagem,
              type: "warning",
            });
            $("#valor").val("");
          }

          for (var a = 0; a < avalistas.length; a++) {
            $this.avalista[a].cpfcnpj = avalistas[a].cpfcnpj;
            $this.avalista[a].nome = avalistas[a].nome;
          }

          $this.getMarcas();
          if (response.data.parcelas) {
            $("#data_primeira_parcela").val(
              $this.$utils.formatDate(
                response.data.proposta.data_primeira_parcela
              )
            );

            $this.oldDataParcelas = $("#data_primeira_parcela").val();

            $this.oldNParcelas = $this.proposta.parcelas;

            var valor_p = response.data.parcelas[0].parcela_iof;
            $("#valor_par").val(valor_p).toFixed(2);
          }

          if (response.data.proposta.simulacao == false) {
            $("input").attr("disabled", true);
            $("select").attr("disabled", true);
          }

          $this.seguro = false; //localStorage.seguro == "true" ? true : false;

          $this.loader = false;
        })
        .catch(function (error) {
          $this.loader = false;
        });
    },

    getModelos: function () {
      this.modelos = [];

      var tipo = "";
      if (this.proposta.tipo_proposta_id == 1) {
        tipo = 1;
      } else if (this.proposta.tipo_proposta_id == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      var $this = this;

      $this.$http
        .get("/fipe/modelos/" + tipo + "/" + $this.veiculo.marca)
        .then(function (response) {
          let anos = response.data["Anos"];
          let anosModelo = [];

          if (tipo == 1) {
            for (let index = 0; index < anos.length; index++) {
              if (
                parseInt(anos[index].Label) >=
                parseInt(moment().format("YYYY") - 15)
              ) {
                anosModelo.push(anos[index]);
              }
            }
          }

          if (tipo == 2) {
            for (let index = 0; index < anos.length; index++) {
              if (
                parseInt(anos[index].Label) >=
                parseInt(moment().format("YYYY") - 15)
              ) {
                anosModelo.push(anos[index]);
              }
            }
          }
          $this.modelos = response.data["Modelos"];
          //$this.anoModelo = tipo == 2 ? anosModelo : anos;
          $this.anoModelo = anosModelo;
          $this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAnosModelo: function () {
      var $this = this;

      if ($this.veiculo.ano) {
        if ($this.veiculo.ano != "") {
          $this.getVeiculo();
        }
      }

      var tipo = "";
      if (this.proposta.tipo_proposta_id == 1) {
        tipo = 1;
      } else if (this.proposta.tipo_proposta_id == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      var veiculo = $this.veiculo.modelo;

      $this.anoModelo = [];

      $this.$http
        .get(
          "/fipe/anomodelo/" + tipo + "/" + $this.veiculo.marca + "/" + veiculo
        )
        .then(function (response) {
          let anos = response.data;
          let anosModelo = [];

          if (tipo == 1) {
            for (let index = 0; index < anos.length; index++) {
              if (
                parseInt(anos[index].Label) >=
                  parseInt(moment().format("YYYY") - 15) ||
                parseInt(anos[index].Label) == 0
              ) {
                anosModelo.push(anos[index]);
              }
            }
          }

          if (tipo == 2) {
            for (let index = 0; index < anos.length; index++) {
              if (
                parseInt(anos[index].Label) >=
                  parseInt(moment().format("YYYY") - 15) ||
                parseInt(anos[index].Label) == 0
              ) {
                anosModelo.push(anos[index]);
              }
            }
          }
          $this.anoModelo = tipo == 2 ? anosModelo : anos;
          $this.anoModelo = anosModelo;
          $this.loader = false;
        });
    },

    getModelosAno: function () {
      var $this = this;
      var tipo = "";

      if (this.proposta.tipo_proposta_id == 1) {
        tipo = 1;
      } else if (this.proposta.tipo_proposta_id == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      $this.$http
        .get(
          "/fipe/modeloanomodelo/" +
            tipo +
            "/" +
            $this.veiculo.marca +
            "/" +
            $this.veiculo.ano
        )
        .then(function (response) {
          $this.modelos = response.data;
          $("#veiculo").select2("open").trigger("focus");
        });
    },

    getVeiculo: function () {
      this.objetoS = {};

      var tipo = "";
      if (this.proposta.tipo_proposta_id == 1) {
        tipo = 1;
      } else if (this.proposta.tipo_proposta_id == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      var $this = this;

      if (
        !$this.veiculo.modelo ||
        $this.veiculo.modelo == "" ||
        $this.veiculo.modelo == null
      ) {
        return $this.getModelosAno();
      }

      var veiculo = $this.veiculo.modelo;

      $this.$http
        .get(
          "/fipe/paramsmodelo/" +
            tipo +
            "/" +
            $this.veiculo.marca +
            "/" +
            veiculo +
            "/" +
            $this.veiculo.ano
        )
        .then(function (response) {
          $this.objeto.marca = response.data.Marca;
          $this.objeto.valor = response.data.Valor.replace("R$ ", "");
          $this.veiculo.valor = response.data.Valor.replace("R$ ", "");
          $this.objeto.valor_fipe = response.data.Valor.replace("R$ ", "");
          $this.proposta.valor_fipe = response.data.Valor.replace("R$ ", "");
          $this.objeto.modelo = response.data.Modelo;
          $this.objeto.ano_modelo = response.data.AnoModelo;
          $this.objeto.fipe_id = response.data.CodigoFipe;
          $this.objeto.tipo_combustivel = response.data.Combustivel;
        });
    },

    getMarcas: function () {
      var tipo = "";
      if (this.proposta.tipo_proposta_id == 1) {
        tipo = 1;
      } else if (this.proposta.tipo_proposta_id == 2) {
        tipo = 2;
      } else {
        tipo = 3;
      }

      var $this = this;
      $this.getDataFeirao();
      $this.marcas = [];

      $this.$http.get("/fipe/marcas/" + tipo).then(function (response) {
        $this.marcas = response.data;
      });
    },
  },

  mounted() {
    this.getPas();
    this.getDataFeirao();
    this.disabledDates.to = new Date(this.dataAtual);
    this.disabledDates.from = new Date(this.dataLimite);

    var $this = this;
    $this.getPas();
    $this.getAnexos();
    $this.getProposta();
  },
};
</script>



// WEBPACK FOOTER //
// src/views/propostas/Editar.vue